import Card from "@imminently/decisively-ui/Card";
import { Skeleton } from "@/ui/primitives/skeleton";

/**
 * Generic loading skeleton for resource cards.
 * Replaces `ResourceLoading` from the deprecated ResourceCard.
 */
export const CardSkeleton = () => (
  <Card className="p-4 rounded-lg gap-3">
    <div className="flex items-start gap-3">
      <Skeleton className="size-10 rounded-full shrink-0" />
      <div className="flex flex-col gap-2 flex-1">
        <Skeleton className="h-4 w-1/2" />
        <Skeleton className="h-3 w-4/5" />
      </div>
    </div>
    <Skeleton className="h-5 w-16 rounded-full" />
    <div className="flex items-center gap-2 pt-3">
      {[1, 2, 3].map(i => (
        <Skeleton key={i} className="size-8 rounded-full" />
      ))}
      <Skeleton className="ml-auto h-7 w-16 rounded-md" />
    </div>
  </Card>
);
